import { useNavigate, useParams } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { CASALE } from "@/data/questionnaire";

export default function StaffThankYouPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <Shell header={null}>
      <div className="min-h-[70vh] flex flex-col items-center justify-center text-center fade-up" data-testid="staff-thank-you-screen">
        <div className="w-20 h-20 rounded-full bg-[#2D4030] text-[#FAF6F0] grid place-items-center font-serif text-4xl font-semibold mb-8">✓</div>
        <p className="eyebrow">{CASALE.name}</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#2C221E] mt-3">Grazie!</h1>
        <p className="text-base sm:text-lg text-[#5C4D46] mt-5 max-w-md">Le tue risposte sono salvate. Puoi restituire il tablet al consulente.</p>
      </div>
      <div className="flex justify-center pb-10">
        <button className="text-sm text-[#B0A096] hover:text-[#5C4D46] underline-offset-4 hover:underline transition-colors min-h-[48px] px-4"
          onClick={() => navigate(`/risultato/${id}`)} data-testid="staff-thank-you-close-btn">
          Sono il consulente: torna al risultato
        </button>
      </div>
    </Shell>
  );
}
